import { io } from "socket.io-client";

const getSocketUrl = () => {
  const localIP = localStorage.getItem("localIP");
  return localIP ? `http://${localIP}:8000` : null;
};

const socketOptions = {
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 3,
  transports: ["websocket", "polling"],
  autoConnect: false, // Don't auto-connect, we'll connect manually when IP is available
};

const initialUrl = getSocketUrl();
export const socket = io(initialUrl || "http://localhost:8000", socketOptions);

// Connect if localIP is available
if (initialUrl) {
  socket.connect();
}

// Function to reconnect socket with current localIP
export const reconnectSocket = () => {
  const url = getSocketUrl();
  if (url) {
    if (socket.connected) {
      socket.disconnect();
    }
    socket.io.uri = url;
    socket.connect();
    console.log("Socket reconnecting to:", url);
  }
};
